const SNAPS_DOMAIN = process.env.NEXT_PUBLIC_SNAPS_CLIENT;
const WEB_DOMAIN = process.env.NEXT_PUBLIC_WEB_CLIENT;

const seo = {
	type: 'website',
	locale: 'en_US',
	favicon: `${WEB_DOMAIN}/favicon.png`,
	photo: `${SNAPS_DOMAIN}/api/image?template=app&platform=Articles&url=docs.playbooks.ai&format=png`,
	title: 'Playbooks Docs',
	description: `Playbooks is an AI-native platform that helps entrepreneurs, business owners, and operators transform ideas into intelligent products. Explore the platform documentation, guides, and APIs.`,
	keywords: `hybrid source software, developer economy, indie developers, software templates, software partials, software starters, software themes, software apps`,
	card: 'summary',
	siteName: 'Playbooks',
	author: 'Playbooks',
	site: '@playbooks_hq',
	baseUrl: process.env.NEXT_PUBLIC_DOCS_CLIENT,
	robots: 'index,follow',
};

export { seo };
